
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 17V7a5 5 0 00-5-5H7a5 5 0 00-5 5v10a5 5 0 005 5h10a5 5 0 005-5z","stroke":"#F2F3F5","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M11.91 11.002l.005-4.186M9.933 7.71l1.893-1.892 2.067 2.067M11.917 17.39l-.008-4.392M9.83 16.393l1.996 1.996 2.17-2.17","stroke":"#F2F3F5","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    